// extracted by mini-css-extract-plugin
export default {"container":"R24pJ8YQk5rNVAQnn85w"};